import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Évite de faire planter tout le site si les variables ne sont pas définies (ex: build Netlify sans config)
  console.error(
    "Configuration Supabase manquante : définissez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY."
  );
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key'
);
